module.exports = __webpack_public_path__ + "img/COWBOY HAT PURPLE.a7ea21c.svg";